import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { toast } from "react-toastify";
import PdfPreview from "../../../../Common/PdfPreview";
import { getFileFromS3 } from "../../../../../utils/helpers";
import useAbortController from "../../../../Common/hooks/useAbortController";

/**
 * Preview modal for chemistry result PDFs on S3 (FAP, Residual Solvents, …).
 * Caller always passes `s3Info` + `title` (see chemistryResultPdfSources.js).
 */
const FapPdfPreviewModal = ({
  open,
  onCancel,
  title = "Result PDF",
  s3Info = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [pdfSrc, setPdfSrc] = useState(null);
  const { setNewAbortController } = useAbortController();

  const fetchPdfSrc = async () => {
    setLoading(true);
    const newAbortController = setNewAbortController();

    const response = await getFileFromS3(
      s3Info.Name,
      { bucket: s3Info.Bucket, region: s3Info.Region },
      false,
      true,
      "application/pdf",
      newAbortController.signal,
    );

    if (response.aborted) {
      setLoading(false);
      return;
    }

    if (response.success && response.blob) {
      setPdfSrc(window.URL.createObjectURL(response.blob));
      setLoading(false);
    } else {
      toast.error(
        response.presignedFailed
          ? "Failed to fetch the presigned URL"
          : `Failed to load the ${title}`,
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && s3Info) {
      fetchPdfSrc();
    } else {
      setPdfSrc(null);
      setLoading(false);
      setNewAbortController();
    }
  }, [open, s3Info]); // eslint-disable-line

  useEffect(() => {
    const blobUrl = pdfSrc;
    return () => {
      if (blobUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [pdfSrc]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width="80vw"
      title={title}
      className="MarkSampleQCModal__FapPdfModal"
    >
      <PdfPreview fileUrl={pdfSrc} loading={loading} />
    </Modal>
  );
};

export default FapPdfPreviewModal;
